import React, { FC, useState } from 'react';
import { Modal, Input, Button } from 'antd';

import { useTranslate } from '@/translations';
import { useUpdateInspectionReg } from '@/api/Inspections';
import { faEdit, Icon } from '@/ui/components';
import { Inspection } from '@/types';

interface InspectionUpdateRegProps {
  inspection: Inspection;
  canEdit?: boolean;
}
export const InspectionUpdateRegNumber: FC<InspectionUpdateRegProps> = ({
  inspection,
  canEdit = false,
}) => {
  const { t } = useTranslate();
  const { mutateAsync: updateInspectionReg } = useUpdateInspectionReg();
  //   const [mileage, setMileage] = useState(inspection.mileage);
  const [reg, setReg] = useState(inspection.regNumber);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleUpdateInspectionReg = async () => {
    try {
      await updateInspectionReg({
        id: inspection.id,
        vin: inspection.vin,
        newReg: reg,
      });
      setIsModalOpen(false);
    } catch (error) {
      console.log('handleUpdateRegNumber: ', { error });
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>{reg}</span>
      {canEdit ? (
        <Icon icon={faEdit} onClick={() => setIsModalOpen(true)} />
      ) : null}
      <Modal
        title={t('updateRegNumber')}
        open={isModalOpen}
        onOk={handleUpdateInspectionReg}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={handleUpdateInspectionReg}
          >
            Save
          </Button>,
          <Button key="back" onClick={() => setIsModalOpen(false)}>
            Return
          </Button>,
        ]}
      >
        <Input
          value={reg}
          onChange={(e) => setReg(e.target.value)}
          style={{ width: '100%' }}
        />
      </Modal>
    </div>
  );
};
